export function setPrintPageSize(sizeStr: string): void {
  const styleNode = document.createElement('style');
  styleNode.appendChild(document.createTextNode(`@page { size: ${sizeStr}; }`));
  const headElement = document.querySelector('head');
  if (headElement) {
    headElement.appendChild(styleNode);
  }
}
